export default "__VITE_ASSET__03e2eb47__"